import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { FONT_SIZE, FONT_WEIGHT, TEXT_COLOR, BACKGROUND_COLOR } from "../GoFurtherStyles";

const CLOSING_CONTENT = {
  CD: {
    titlePrefix: "まずは一部車両から、",
    body: (
      <>
        EVでLPG同等の稼働・営収を実現するため、まずは一部車両での外部充電活用からスタートしましょう。
        <br />
        その後の全車両展開や2人車運用も、本画面を通じてサポート・ご案内いたします。
      </>
    ),
  },
  B: {
    titlePrefix: "営業所全体で、",
    body: (
      <>
        EVでLPG同等の稼働・営収を実現するため、全車両でLPG同等走行を横展開していきましょう。
        <br />
        本画面で施策の効果の確認と、追加の施策をお試しいただければ幸いです。
      </>
    ),
  },
} as const;

interface GoFurtherClosingSectionProps {
  isPersonaAB?: boolean;
}

const GoFurtherClosingSection: React.FC<GoFurtherClosingSectionProps> = ({ isPersonaAB = false }) => {
  const content = isPersonaAB ? CLOSING_CONTENT.B : CLOSING_CONTENT.CD;
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 4,
        px: 4,
        py: 6,
        bgcolor: BACKGROUND_COLOR.SECONDARY_DARK,
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-12%",
          left: "1%",
          width: "150%",
          height: "150%",
          backgroundImage: `repeating-linear-gradient(180deg, ${BACKGROUND_COLOR.BORDER} 0, ${BACKGROUND_COLOR.BORDER} 1px, transparent 1px, transparent 40px), repeating-linear-gradient(60deg, ${BACKGROUND_COLOR.BORDER} 0, ${BACKGROUND_COLOR.BORDER} 1px, transparent 1px, transparent 40px)`,
          backgroundPosition: "0 0, 0 2px",
          backgroundColor: BACKGROUND_COLOR.SECONDARY_DARK,
          transform: "rotate(-30deg)",
          pointerEvents: "none",
          zIndex: 0,
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 2, display: "flex", alignItems: "center", gap: 5 }}>
        <Box
          sx={{
            bgcolor: BACKGROUND_COLOR.WHITE,
            borderRadius: 4,
            p: 5,
            width: "640px",
          }}
        >
          <Typography sx={{ fontWeight: FONT_WEIGHT.BOLD, fontSize: FONT_SIZE.headline4, color: TEXT_COLOR.PRIMARY }}>
            {content.titlePrefix}
            <br />
            <Box component="span" sx={{ color: TEXT_COLOR.SUCCESS }}>
              LPG同等を達成するEV運用
            </Box>
            の
            <br />
            確かな手応えを。
          </Typography>

          <Typography sx={{ mt: 2, fontSize: FONT_SIZE.body2, color: TEXT_COLOR.SECONDARY, fontWeight: FONT_WEIGHT.NORMAL }}>
            {content.body}
          </Typography>

          <Typography sx={{ mt: 2, fontSize: FONT_SIZE.body2, color: TEXT_COLOR.SECONDARY, fontWeight: FONT_WEIGHT.NORMAL }}>
            ご不明な点がございましたら、
            <Link href="mailto:gx_contact@goinc.jp" underline="none" sx={{ color: "inherit" }}>
              gx_contact@goinc.jp
            </Link>
            までお気軽にご連絡ください。
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Box
            component="img"
            src="/charging_spot.png"
            alt="EV charging illustration"
            sx={{
              width: 212,
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default GoFurtherClosingSection;
